import { ANALYTIC_EVENTS } from "@/const/event.constants"
import { HeaderPage } from "@/organisms/HeaderPage"
import { HighProfileVulnerability } from "@/organisms/HighProfileVulnerability"
import { PageTemplate } from "@/templates/PageTemplate"
import { FunnelTriagePage } from "../../organisms/FunnelTriagePage"
import { SelectionProvider } from "../../organisms/SelectionProvider"
import { TriageTab } from "../../organisms/TriageTab"

import styles from "./IssuesPage.module.scss"

export const IssuesPage = () => {
  return (
    <PageTemplate
      full
      header={<HeaderPage titleTranslationKey="Triage" />}
      classes={{ main: styles.main }}
    >
      <HighProfileVulnerability placement="triage" />
      <FunnelTriagePage
        size="sm"
        MixPanelEvent={ANALYTIC_EVENTS.TRIAGE.CARD_FUNNEL_CLICK}
      />
      <SelectionProvider>
        <TriageTab />
      </SelectionProvider>
    </PageTemplate>
  )
}
